module.exports = __webpack_public_path__ + "static/media/heart-with-social-media-logo-of-twitter-svgrepo-com.673d5ee4.svg";